import { useContext, Fragment } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Title from '../../shared/Title';
import FFPaper from '../../shared/FFPaper';
import WeeklyTrafficChart from './WeeklyTrafficChart';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import ChartContainer from '../../shared/ChartContainer';
import { TrafficAnalyticsContext } from '../../../context/trafficanalytics-context';
import BlueSkeleton from '../../shared/BlueSkeleton';

const handler = (menu: string) => {
    console.log(menu);
}


export default function WeeklyTrafficCard() {
    const { status, data, isFetching } = useContext(TrafficAnalyticsContext);

    const info = 'Measures the amount of visitors in the current week';
    return (
        <Grid item={true} xs={12} md={12} sm={12} lg={5}>
            <FFPaper
                elevation={3}
                sx={{
                    display: 'flex',
                    flexDirection: {
                        xs: 'column',
                        md: 'row'
                    },
                    pb: 3,
                    position: 'relative',
                    minHeight: 200
                }}
            >
                <KebabMenu
                    menus={defaultMenus}
                    handler={handler}
                />

                {isFetching && <BlueSkeleton width={'90%'} height={'100%'} sx={{ mt: 1, ml: 'auto', mr: 'auto' }} />}


                {status === 'success' && !isFetching && <Fragment>
                    <Box sx={{
                        maxHeight: '90%',
                        flex: {
                            xs: '1 0 100%',
                            sm: '1 0 70%'
                        }
                    }}>

                        <Box sx={{
                            p: '6px',
                           
                        }}>
                            <Title info={info}>Weekly Traffic</Title>
                        </Box>

                        <Box sx={{
                            width: '100%',
                            minHeight: 170,
                            height: 170,
                        }}>

                            <ChartContainer>
                                <WeeklyTrafficChart data={data?.trafficAnalyticsWeeklyTraffic.value} />
                            </ChartContainer>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: 'flex', 
                        flex: {
                            xs: '1 0 100%',
                            sm: '1 0 30%'
                        },
                        flexDirection: 'column', pb: 3, pt: 1
                    }}>
                        <Typography
                            sx={{
                                textAlign: 'center',
                            }}
                        >Total Visitors</Typography>
                        <Box sx={{
                            verticalAlign: 'middle',
                            textAlign: 'center',
                            flexGrow: 1,
                            display: 'table',
                            mt: 'auto',
                            mb: 'auto',
                        }}>
                            <Typography color="secondary" sx={{
                                verticalAlign: 'middle',
                                textAlign: 'center',
                                display: 'table-cell',
                                fontSize: 32,
                                fontWeight: 600,
                                color: (theme) => theme.palette.text.secondary,
                            }}>11,529</Typography>
                        </Box>
                        <Box sx={{ display: 'block', margin: '0 auto' }}>
                            <Typography sx={{
                                backgroundColor: 'success.dark',
                                fontSize: 11,
                                color: 'primary.main',
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                padding: '2px 2px 2px 2px',
                            }}>
                                <NorthEastIcon sx={{ color: 'success.light', fontSize: 12, verticalAlign: 'middle' }}
                                />
                                15%
                            </Typography>
                            <Typography color="primary" sx={{
                                verticalAlign: 'middle',
                                fontSize: 12,
                                textAlign: 'center',
                                display: 'inline',
                                paddingLeft: 1,
                            }}>From last week</Typography>
                        </Box>
                    </Box>
                </Fragment>}

            </FFPaper>
        </Grid>

    )

}
